/**
 * Presets visuales para columnas. Curados a mano — NO permitir estilos arbitrarios.
 * Se aplican via `styleId` en `columnConfig.core[col].styleId` (admin-only).
 */

export interface ColumnStylePreset {
  id: string;
  label: string;
  className: string;
  description: string;
}

export const COLUMN_STYLE_PRESETS: ColumnStylePreset[] = [
  {
    id: 'text',
    label: 'Texto plano',
    className: '',
    description: 'Sin formato, color y peso heredados de la tabla.',
  },
  {
    id: 'text-muted',
    label: 'Texto secundario',
    className: 'text-gray-500',
    description: 'Gris claro, para datos accesorios.',
  },
  {
    id: 'bold',
    label: 'Negrita',
    className: 'font-bold text-gray-900',
    description: 'Solo negrita, sin fondo.',
  },
  {
    id: 'highlight-1',
    label: 'Destacado 1',
    className: 'font-bold text-gray-900 bg-gray-100 px-2 py-0.5 rounded',
    description: 'Negrita con fondo gris claro.',
  },
  {
    id: 'highlight-2',
    label: 'Destacado 2',
    className: 'font-bold text-gray-900 bg-gray-200 px-2 py-0.5 rounded',
    description: 'Negrita con fondo gris medio.',
  },
  {
    id: 'pill-blue',
    label: 'Píldora azul',
    className: 'inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full',
    description: 'Badge azul.',
  },
  {
    id: 'pill-green',
    label: 'Píldora verde',
    className: 'inline-block px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full',
    description: 'Badge verde.',
  },
  {
    id: 'pill-red',
    label: 'Píldora roja',
    className: 'inline-block px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full',
    description: 'Badge rojo.',
  },
  {
    id: 'pill-orange',
    label: 'Píldora naranja',
    className: 'inline-block px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full',
    description: 'Badge naranja.',
  },
  {
    id: 'pill-yellow',
    label: 'Píldora amarilla',
    className: 'inline-block px-2 py-1 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full',
    description: 'Badge amarillo.',
  },
  {
    id: 'pill-cyan',
    label: 'Píldora celeste',
    className: 'inline-block px-2 py-1 bg-cyan-100 text-cyan-800 text-xs font-medium rounded-full',
    description: 'Badge celeste.',
  },
  {
    id: 'pill-violet',
    label: 'Píldora violeta',
    className: 'inline-block px-2 py-1 bg-violet-100 text-violet-800 text-xs font-medium rounded-full',
    description: 'Badge violeta.',
  },
  {
    id: 'code-mono',
    label: 'Monoespaciado',
    className: 'font-mono text-xs text-gray-700',
    description: 'Para SKUs, IDs, códigos.',
  },
];

export const COLUMN_STYLE_PRESETS_BY_ID: Record<string, ColumnStylePreset> =
  COLUMN_STYLE_PRESETS.reduce((acc, p) => { acc[p.id] = p; return acc; }, {} as Record<string, ColumnStylePreset>);

export function getStylePresetClassName(styleId?: string): string {
  if (!styleId) return '';
  return COLUMN_STYLE_PRESETS_BY_ID[styleId]?.className || '';
}

export function getStylePresetById(styleId?: string): ColumnStylePreset | null {
  if (!styleId) return null;
  return COLUMN_STYLE_PRESETS_BY_ID[styleId] || null;
}
